<template>
  <transition name="slide-fade" mode="in-out">
    <div class="promotor-tranches" v-if="getTranches.length || getTranchesPending">
      <div class="headline">
        <h2 class="col s12 m6">Historia wypłat</h2>
      </div>
      <div class="card-content">
        <table class="responsive-table highlight centered">
          <thead>
            <tr>
              <th>Nr transzy<span class="hide-on-med-and-down"><br />(tytuł faktury/rachunku)</span></th>
              <th>Wartość</th>
              <th>Status</th>
              <th>Data utworzenia</th>
              <th>Zobacz<span class="hide-on-med-and-down"><br />szczegóły</span></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="trancheItem in getTranches" :key="trancheItem.token">
              <td>{{ trancheItem.token }}</td>
              <td>{{ trancheItem.amount | currency }}</td>
              <td>{{ trancheItem.changes[0].status }}</td>
              <td>{{ trancheItem.created_at | date }}</td>
              <td>
                <button class="btn" @click="openModal(trancheItem)">
                  <i class="mfind-icon-search"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <modal-tranche-history v-if="showModal" :tranche="tranche" :showModal="showModal"
                               @close="showModal=!showModal"/>

        <Loader :loading="getTranchesPending" type=""/>
      </div>
    </div>
  </transition>
</template>

<script>
  import Loader from '@/components/loader'
  import ModalTrancheHistory from '@/components/modalTrancheHistory'
  import { createNamespacedHelpers } from 'vuex'
  const { mapGetters } = createNamespacedHelpers('tranches')
  export default {
    components: { Loader, ModalTrancheHistory },
    data () {
      return {
        tranche: false,
        showModal: false
      }
    },
    methods: {
      openModal (tranche) {
        this.showModal = true
        this.tranche = tranche
      }
    },
    created () {
      this.$store.dispatch('tranches/getPromotorTranches')
    },
    computed: {
      ...mapGetters([ 'getTranches', 'getTranchesPending' ])
    }
  }
</script>

<style lang="scss">
  .promotor-tranches {
    table {
      td, th {
        color: #000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// promotorTranches.vue?25919984